module.exports = __webpack_public_path__ + "static/overlays-859cbfb1c9bf05de59631d6e840d9708.jpg";